import { render, staticRenderFns } from "./HeyPhilVideo.vue?vue&type=template&id=056e34f6&scoped=true&"
import script from "./HeyPhilVideo.vue?vue&type=script&lang=js&"
export * from "./HeyPhilVideo.vue?vue&type=script&lang=js&"
import style0 from "./HeyPhilVideo.vue?vue&type=style&index=0&id=056e34f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e34f6",
  null
  
)

export default component.exports